<template>
  <div class="about-us">
    <div class="about-us-banner">
      <div class="about-us-banner-img-cover"></div>
      <div class="about-us-banner-title">About Us</div>
      <div class="about-us-banner-sub-title">Choose what to learn here</div>
      <div class="about-us-banner-description">
        Hello everyone! Thank you for finding out our website! yah~~ First of
        all, we are really happy and proud of you who always love to learn new
        language. You must be a very brave person!
        <br /><br />
        ATA Learning Hub is an online education platform open to all Teens and
        Adults who love learning new languages. We upload Basic Chinese class /
        Business Chinese class / Medical Chinese class every week on YouTube and
        Daily Chinese in multi-social media platforms!
        <br /><br />
        You can purchase our online course according to your needs . We also
        provide one-to-one private online Chinese lessons!
        <br /><br />
        Our mission is to offer targeted help for everyone in different fields.
      </div>
    </div>
    <div class="about-us-content-background">
      <div class="about-us-content">
        <div
          class="about-us-card"
          v-for="teacher in teachers"
          :key="teacher.key"
        >
          <div class="about-us-content-banner">
            <img :src="teacher.avatar" />
          </div>
          <div class="about-us-content-title">
            {{ teacher.name }}
          </div>
          <div class="about-us-content-description">
            <p v-html="teacher.description"></p>
          </div>
        </div>
        <!-- <div class="about-us-card">
          <div class="about-us-content-banner">
            <img src="../assets/img/anna.jpg" />
          </div>
          <div class="about-us-content-title">Anna Sha</div>
          <div class="about-us-content-description">
            Hello everyone this is teacher ANNA. I’m a native speaker with an
            international Chinese Language teacher certificate and also a
            Chinese teacher working in Singapore. I graduated from Adamson
            University as a major of Nursing and pursued my masters of
            international business in Singapore. I believe that my diverse
            curriculum can help everyone!
            <br /><br />
            Sign in with us and let’s explore together!
          </div>
        </div> -->
      </div>
    </div>
    <!--
        <FooterBanner />
        -->
  </div>
</template>
<script>
//import FooterBanner from './FooterBanner.vue';

export default {
  components: {
    //FooterBanner
  },
  name: "AboutUs",
  data() {
    return {
      items: 6,
      teachers: [
        {
          id: 1,
          name: "Anna Sha",
          description:
            "Hello everyone this is teacher ANNA. I’m a native speaker with an international Chinese Language teacher certificate and also a Chinese teacher working in Singapore. I graduated from Adamson University as a major of Nursing and  pursued my masters of international business in Singapore. I believe that my diverse curriculum can help everyone!<br><br>Sign in with us and let’s explore together!",
          avatar: "../assets/teachers/anna.jpg",
        },
        {
          id: 2,
          name: "Miranda Bai",
          description:
            "Hello everyone this is teacher MIRANDA. I’m a native speaker with an international Chinese Language teacher certificate and also a Chinese teacher working in Singapore. I graduated from Adamson University as a major of Nursing and pursued my masters of international business in Singapore. I believe that my diverse curriculum can help everyone!",
          avatar: "../assets/teachers/miranda.jpg",
        },
        {
          id: 3,
          name: "Angela Peng (Peng Hui)",
          description:
            "Ms Angela has been living in Singapore since 2009 and excel in academic study and work.<br><br>She holds the CTCSOL (Certificate for Teacher of Chinese to Speakers of Other Languages), which is an official recognized certification in teaching Chinese for non- native speakers. She is also a certified translator and Interpreters with certificate of CATTI (China Accreditation Test For Translators and Interpreters), and suitable for doing relatively formal interpretations/translations in the institutions focusing on businesses and can be engaged in formal and demanding interpretations/translations for negotiations and conferences, and accompanying interpretations. In the meantime, she holds the position of Literature Editor at Yanhuang Culture Study Society in Singapore.<br><br>Ms Angela has been providing home and online tuitions since year 2012 and offer customised language learning lessons based on individual/corporate needs. She has provided overseas online teachings of Chinese culture and language learnings to students from Indonesia, Sri-Lanka, Cambodia, Nepal and Thailand, age ranging from 7 years old to adults. Ms Angela always believes that learning Chinese is more than just a language. She hopes that all the students can benefit from the learning and apply the communication skills in the work and daily life, fostering a multi-cultural and dimensional way of thinking in the rising globalization of the world.",
          avatar: "../assets/teachers/angela.jpg",
        },
        {
          id: 4,
          name: "Celia Li",
          description:
            "<div>Celia Li is a seasoned educator with a robust academic background and a deep commitment to both teaching and scholarly research. She successfully completed her Master&rsquo;s and Ph.D. degrees in medical studies in Thailand,where the curriculum was delivered entirely in English. With fouryears of experience teaching Mandarin to international students in Thailand, Celia has honed her ability to deliver high-quality language instruction to a diverse student population.</div><div><br />Celia is known for her approachable demeanor, strong sense of responsibility, and exceptional communication skills. She is particularly adept at employing innovative teaching methods to foster student engagement and enhance interest in Mandarin. Her qualifications include a Teaching Certificate, Level 2 Certificate of Proficiency in Mandarin Chinese, and a TEFL Certification.</div><div>&nbsp;</div><div>Her professional credentials include a Level 2 Certificate of Proficiency in Mandarin Chinese and IELTS certification, reflecting her strong bilingual capabilities in both Chinese and English. This linguistic proficiency enables her to effectively bridge communication between students of varying backgrounds. Celia&rsquo;s academic achievements, coupled with her unwavering dedication to the field of education, position her as a highly capable and committed educator, focused on delivering the highest standards of academic excellence and support.</div>",
          avatar: "../assets/teachers/celia.png",
        },
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
  },
};
</script>
<style lang='scss' type='text/css'>
@import "../styles/pc/AboutUs.scss";
@import "../styles/mobile/AboutUs.scss";
</style>
